<app-header></app-header>
<div id="outlet">
    <router-outlet></router-outlet>
</div>
<app-footer></app-footer>